
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Benefit } from '../../../../models/benefit.model';
import { AlertService } from '../../../../services/alert.service';
import { ActivatedRoute } from '@angular/router';
import { ProductBenefit } from '../../../../models/product-benefit.model';
import * as _ from 'lodash';
import { BenefitClassification } from '../../../../models/benefit-classification.model';
import { Observable } from 'rxjs';


@Component({
    selector: 'link-benefit-modal',
    template: require('./link-benefit-modal.component.html'),
    styles: [require('./link-benefit-modal.component.css')]
})
export class LinkBenefitModalComponent {
    productId: number;
    benefits: Benefit[] = [];
    benefitClassifications: Observable<BenefitClassification[]>;
    currentBenefitClassificationId = 2;
    constructor(private route: ActivatedRoute, private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<LinkBenefitModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.productId = parseInt(data.productId.toString());
        this.getBenefitsByExceptProductId();
        this.benefitClassifications = this.apiService.getBenefitClassifications();
    }

    getBenefitsByExceptProductId() {
        this.apiService.getBenefitsByExceptProductId(this.productId).subscribe(r => {
            r = _.filter(r, { benefitClassificationId: this.currentBenefitClassificationId})
            r = _.orderBy(r, ['benefitCode','benefitName']);
            this.benefits = r;
        })
    }

    classificationChanged() {
        this.getBenefitsByExceptProductId();
    }

    ok() {
        var selectedBenefits = _.filter(this.benefits, { 'isSelected': true });

        var productBenefits = _.map(selectedBenefits, i => {
            return new ProductBenefit({ benefitId: i.benefitId, productId: this.productId });
        })
        this.apiService.createProductBenefitsBulk(productBenefits).subscribe(r => {
            if (r) {
                this.dialogRef.close(r);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/products/product-detail/link-benefit-modal/link-benefit-modal.component.ts